type InternalTeamUserLike =
  | {
      primaryOrganisation?: number | null;
    }
  | null
  | undefined;

const INTERNAL_TEAM_ORGANISATION_ID = 1;

export function isInternalTeamUser(user: InternalTeamUserLike): boolean {
  return user?.primaryOrganisation === INTERNAL_TEAM_ORGANISATION_ID;
}
